module.exports = __webpack_public_path__ + "static/media/main-image.62b156bc.png";